import * as types from './action_types';
import UserFollower from '../../services/user_follower';
import DateMaster from '../utils/date_master';

export const load = (slug) => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.FOLLOWS_LOADING });
      const followsData = await UserFollower.follows(slug);
      const follows = []

      for (let followData of followsData) {
        const followedUserData = followData.followed_user;
        const followedUser = {
          slug: followedUserData.slug,
          name: followedUserData.name,
          headline: followedUserData.headline,
          tacksCount: followedUserData.tacks_count,
          followedAt: DateMaster.parseUTC(followData.created_at),
          hasActiveSubscription: followedUserData.has_active_subscription
        };

        follows.push(followedUser);
      }
      dispatch({ type: types.FOLLOWS_LOADED, follows });
    } catch(error) {
      dispatch({ type: types.FOLLOWS_ERROR, error });
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/follows/actions.js